import type {
  AudienceCampaignMetrics,
  AudienceDetails,
} from '@/components/audiences/audience-details-types';
import { mapFilterDtoToTree } from '@/components/audiences/map-filter-dto-to-tree';
import type { AudienceDto } from '@/generated/korza-api-client/types.gen';

export function mapAudienceUserCounts(
  dto: AudienceDto,
  options?: {
    previewTargetUserCount?: number;
    membersTotal?: number;
  }
) {
  return {
    targetUsersCount:
      dto.cachedTargetUserCount ??
      options?.previewTargetUserCount ??
      options?.membersTotal ??
      0,
    totalUserbaseCount: dto.cachedTotalNotificationEnabledUserCount ?? 0,
  };
}

export function mapAudienceCampaignAnalytics(
  dto: AudienceDto
): AudienceCampaignMetrics {
  return dto.campaignAnalytics;
}

export function mapAudienceDtoToDetails(dto: AudienceDto): AudienceDetails {
  return {
    id: dto.id,
    name: dto.name,
    filterTree:
      dto.type === 'filter' && dto.filters
        ? mapFilterDtoToTree(dto.filters)
        : null,
    sentCampaignsCount: dto.sentCampaignsCount,
  };
}
